import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Carousel } from "vue3-carousel";
import { Component, Emit, Ref, Vue } from "vue-facing-decorator";
let QuizViewerCarousel = class QuizViewerCarousel extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "carouselRef", void 0);
  }
  onSlideChange(eventData) {
    return eventData;
  }
  next() {
    const prevSlideIndex = this.getCurrentSlide();
    this.carouselRef.next();
    this.$nextTick(() => {
      const currentSlideIndex = this.getCurrentSlide();
      const slidesCount = this.getSlidesCount();
      this.onSlideChange({
        currentSlideIndex,
        prevSlideIndex,
        slidesCount
      });
    });
  }
  slideTo(slideIndex) {
    this.carouselRef.slideTo(slideIndex);
  }
  getCurrentSlide() {
    return this.carouselRef.data.currentSlide.value;
  }
  getSlidesCount() {
    return this.carouselRef.data.slidesCount.value;
  }
};
__decorate([Ref()], QuizViewerCarousel.prototype, "carouselRef", void 0);
__decorate([Emit('slide-end')], QuizViewerCarousel.prototype, "onSlideChange", null);
QuizViewerCarousel = __decorate([Component({
  components: {
    Carousel
  }
})], QuizViewerCarousel);
export default QuizViewerCarousel;